export const recieveSchedulingStatus = (status) => {
  return {
    type: 'RECIEVE_SCHEDULING_STATUS',
    status,
  }
}
